import { type ResolvedContextData } from '@common/defaults/ContextData';
import { CommentIcon } from '@common/svg/icons/components/CommentIcon';
import { WidgetType } from '@common/types/Sidebar';
import { getT, Ns } from '@web/i18n';
import { NewsBlockList } from '@web/molecules/NewsBlockItem/molecules/NewsBlockListItem/NewsBlockList';
import { NewsBlockListItem } from '@web/molecules/NewsBlockItem/molecules/NewsBlockListItem/NewsBlockListItem';
import { type NewsBlockListItemProps } from '@web/molecules/NewsBlockItem/molecules/NewsBlockListItem/types';
import { SimpleWidget } from '@web/organisms/SimpleWidget';
import { type SimpleWidgetConfig } from '@web/organisms/SimpleWidget/SimpleWidget.types';

interface Props {
    contextData: ResolvedContextData;
    dataList?: NewsBlockListItemProps[];
    isTabbedWidget?: boolean;
}

export const widgetConfig: SimpleWidgetConfig = {
    title: 'most-comments.title',
    type: WidgetType.MOST_COMMENTED,
};

export const Widget = ({ contextData, dataList, isTabbedWidget }: Props) => {
    const __sidebar = getT(contextData.context.locale, Ns.Sidebar);
    const title = __sidebar(widgetConfig.title);
    const metaSuffix = __sidebar('most-comments.count');
    return (
        <SimpleWidget contextData={contextData} title={title} isTabbedWidget={isTabbedWidget}>
            <NewsBlockList>
                {dataList?.map((data, i) => (
                    <NewsBlockListItem
                        key={i}
                        contextData={contextData}
                        metaSuffix={metaSuffix}
                        metaIcon={<CommentIcon />}
                        {...data}
                    />
                ))}
            </NewsBlockList>
        </SimpleWidget>
    );
};
